import { useQuery } from '@tanstack/react-query';
import { dashboardService, type DashboardMetrics, type ActividadReciente } from '@/services/dashboard';

export function useDashboardMetrics() {
  return useQuery<DashboardMetrics>({
    queryKey: ['dashboard', 'metrics'],
    queryFn: () => dashboardService.getMetricas(),
    refetchInterval: 300_000, // Fallback every 5min (WS handles real-time)
    staleTime: 60_000,
  });
}

export function useActividadReciente(limit = 10) {
  return useQuery<ActividadReciente[]>({
    queryKey: ['dashboard', 'actividad-reciente', limit],
    queryFn: () => dashboardService.getActividadReciente(limit),
    refetchInterval: 300_000, // Fallback every 5min (WS handles real-time)
  });
}

export function useTicketsPorMes() {
  return useQuery({
    queryKey: ['dashboard', 'tickets-por-mes'],
    queryFn: () => dashboardService.getTicketsPorMes(),
    staleTime: 300000, // 5 minutos
  });
}

